import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemKeys } from '../registerItemKeys'
import { LinkedProcesses } from '@core/entities/linkedProcesses'

const transformer: (data) => LinkedProcesses = (data) => {
  return LinkedProcesses.new(data)
}

export const useGetRegisterItemLinkedProcess = (
  payload: RequestTypes['getRegisterItemLinkedProcesses'],
  options: UseQueryOptions<LinkedProcesses, RequestErrorType> = {},
) => {
  const registerItemTimeline = registerItemKeys
    .byId(payload)
    ._ctx.linkedProcesses(payload)

  return useQuery({
    select: transformer,
    ...registerItemTimeline,
    ...options,
  })
}
